var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", { attrs: { id: "container-request" } }, [
        _c(
          "div",
          {
            staticClass: "row col-12",
            attrs: { slot: "header" },
            slot: "header"
          },
          [_c("h3", [_vm._v("Solicitud de Materiales")])]
        ),
        _c(
          "div",
          { staticStyle: { "text-align": "right", "margin-bottom": "5px" } },
          [
            _c("span", [_vm._v(" Viendo documentos que ingresaron ")]),
            _vm.rangeSelected.valor !== "personalizado"
              ? _c("span", [
                  _vm._v(" " + _vm._s(_vm.rangeSelected.nombre) + " ")
                ])
              : _vm._e(),
            _vm.rangeSelected.valor === "personalizado"
              ? _c(
                  "span",
                  [
                    _vm._v(" entre el "),
                    _c("datetime", {
                      attrs: {
                        "input-class": "input-date",
                        phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                        "value-zone": "local",
                        format: "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.rangeFrom,
                        callback: function($$v) {
                          _vm.rangeFrom = $$v
                        },
                        expression: "rangeFrom"
                      }
                    }),
                    _vm._v(" y el "),
                    _c("datetime", {
                      attrs: {
                        "input-class": "input-date",
                        phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                        "value-zone": "local",
                        format: "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.rangeUntil,
                        callback: function($$v) {
                          _vm.rangeUntil = $$v
                        },
                        expression: "rangeUntil"
                      }
                    }),
                    _c(
                      "span",
                      [
                        _c("vs-button", {
                          staticClass: "ml-3 d-inline",
                          attrs: {
                            radius: "",
                            color: "primary",
                            type: "border",
                            icon: "search",
                            size: "small"
                          },
                          on: {
                            click: function($event) {
                              return _vm.materialRequest()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "vs-dropdown",
              {
                staticStyle: { "margin-left": "15px" },
                attrs: { "vs-trigger-click": "" }
              },
              [
                _c(
                  "a",
                  { staticClass: "a-icon", attrs: { href: "#" } },
                  [
                    _vm._v(" Cambiar "),
                    _c("vs-icon", { attrs: { icon: "expand_more" } })
                  ],
                  1
                ),
                _c(
                  "vs-dropdown-menu",
                  _vm._l(_vm.ranges, function(range) {
                    return _c(
                      "vs-dropdown-item",
                      {
                        key: range.valor,
                        staticStyle: { width: "200px" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.selectRange(range)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(range.nombre) + " ")]
                    )
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "row my-3" }),
        _c(
          "form",
          {
            attrs: { autocomplete: "off", "data-vv-scope": "search-material" },
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("div", { staticClass: "row mb-5" }, [
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("label", [_vm._v("Solicitante")]),
                  _c("ListUser", {
                    attrs: {
                      label: "",
                      name: "targetUserId",
                      placeholder: "Usuario"
                    },
                    model: {
                      value: _vm.searchRequestName,
                      callback: function($$v) {
                        _vm.searchRequestName = $$v
                      },
                      expression: "searchRequestName"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "col-md-3" }, [
                _c("label", [_vm._v("Estado")]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchStatus,
                        expression: "searchStatus"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "select" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.searchStatus = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", {
                      attrs: { selected: "" },
                      domProps: { value: { value: 0, text: "" } }
                    }),
                    _vm._l(_vm.listStatus, function(option) {
                      return _c(
                        "option",
                        {
                          key: option.key,
                          domProps: {
                            value: { value: option.key, text: option.name }
                          }
                        },
                        [_vm._v(" " + _vm._s(option.name) + " ")]
                      )
                    })
                  ],
                  2
                )
              ]),
              _c("div", { staticClass: "col-md-3" }),
              _c(
                "div",
                { staticClass: "col-md-2 align-self-end" },
                [
                  _c(
                    "vs-chip",
                    {
                      staticStyle: { cursor: "pointer" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.materialRequest($event)
                        }
                      }
                    },
                    [
                      _c("vs-avatar", {
                        attrs: { icon: "search", color: "primary" }
                      }),
                      _c("strong", [_vm._v("Buscar")])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]
        ),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("b-table", {
                attrs: {
                  hover: "",
                  fields: _vm.fieldMaterialsRequest,
                  items: _vm.listMaterialsRequest
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(monto)",
                    fn: function(row) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("toCurrency")(
                                row.item.precioSolicitudTotal
                              )
                            ) +
                            " "
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(statusCode)",
                    fn: function(row) {
                      return [
                        row.item.statusCode === _vm.materialState.CREATED
                          ? _c(
                              "vs-chip",
                              { attrs: { title: row.item.statusDescription } },
                              [
                                _c("vs-avatar", {
                                  attrs: { icon: "schedule", color: "#43C3B9" }
                                }),
                                _vm._v(
                                  " " + _vm._s(row.item.statusDescription) + " "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        row.item.statusCode === _vm.materialState.APPROVED
                          ? _c(
                              "vs-chip",
                              { attrs: { title: row.item.statusDescription } },
                              [
                                _c("vs-avatar", {
                                  attrs: { icon: "schedule", color: "#26bd6a" }
                                }),
                                _vm._v(
                                  " " + _vm._s(row.item.statusDescription) + " "
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "cell(action)",
                    fn: function(row) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm" },
                            on: {
                              click: function($event) {
                                return _vm.getRequestDetail(row.item.id)
                              }
                            }
                          },
                          [
                            _c("feather-icon", {
                              attrs: { icon: "SearchIcon" }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "row col-12" }, [
        _c("div", { staticClass: "col-lg-4" }, [
          _c("div", { staticClass: "mt-5" }, [
            _vm._v(" Mostrando "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rowspp,
                    expression: "rowspp"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.rowspp = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.materialRequest
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "10", selected: "selected" } }, [
                  _vm._v("10")
                ]),
                _c("option", { attrs: { value: "15" } }, [_vm._v("15")]),
                _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
                _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
              ]
            ),
            _vm._v(" registros por página. ")
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-lg-8" },
          [
            _c(
              "vs-row",
              [
                _c(
                  "vs-col",
                  { staticClass: "mt-4", attrs: { "vs-w": "12" } },
                  [
                    _c("fb-paginacion", {
                      attrs: { total: _vm.pagination.pages },
                      on: { change: _vm.onPageChange },
                      model: {
                        value: _vm.actualPage,
                        callback: function($$v) {
                          _vm.actualPage = $$v
                        },
                        expression: "actualPage"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("PopUpRequestDetail", { ref: "fromRequestDetailModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }